import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { BRAND_HOMEPAGE, BRAND_NAME } from '@constants/constants';

import './AccountReview.scss';

export default function AccountReview() {
  return (
    <div className='text-center my-4 d-flex flex-column rounded-1 bg-white box-shadow-50 gap-3 account-review-wrapper'>
      <FontAwesomeIcon icon={faCircleCheck} className='primary' fontSize={40} />
      <h1 className='fw-semibold mb-0'>Welcome to {BRAND_NAME}!</h1>
      <p className='fw-normal mb-0'>
        We will review your account request. You will receive an email once the account(s) are ready to use.
      </p>
      <Button as='a' className='align-self-center mt-md-2' href={BRAND_HOMEPAGE}>
        {BRAND_NAME} Website
      </Button>
    </div>
  );
}
